type Props = React.SVGProps<SVGSVGElement> & { size?: number; color?: string };

export const ExpandHorizontalIcon = ({
  size = 20,
  color = 'var(--muted-foreground)',
  ...rest
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 20"
      {...rest}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M7.173 4.843 10 2.015m0 0 2.828 2.828m-2.828-2.828v6.6m-2.829 7.542 2.829 2.828m0 0 2.828-2.828m-2.828 2.828v-6.6"
      />
    </svg>
  );
};

export const CollapseHorizontalIcon = ({
  size = 20,
  color = 'var(--muted-foreground)',
  ...rest
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 20"
      {...rest}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M7.173 5.786 10 8.614m0 0 2.828-2.828m-2.828 2.828v-6.6m-2.829 13.2 2.829-2.828m0 0 2.828 2.828m-2.828-2.828v6.6"
      />
    </svg>
  );
};
